export default __webpack_public_path__ + "static/pragicts-partnerships-banner-ditgital-outreach-064c84036a586d43d51fbdab8d63685a.jpg";